<template>
	<slot :name="searchStore.searchType"></slot>
</template>

<script setup lang="ts">
import { useSearchStore } from '@stores/useSearchStore';

const searchStore = useSearchStore();
</script>
